import { Dispositivo } from './Dispositivo';

import brandXiaomi from '../../../images/dispositivos/brand-xiaomi.svg';
import xiaomi from '../../../images/dispositivos/xiaomi.png';

import brandGoogle from '../../../images/dispositivos/brand-google.svg';
import google from '../../../images/dispositivos/google.png';

import brandAmino from '../../../images/dispositivos/brand-amino.svg';
import amino from '../../../images/dispositivos/amino.png';


function ListadoDispositivos() {

    return (

    <section className="ListadoDispositivos">
        <div className="wrap">
            <h2 className="titles">Convierte <span>en smart tu TV!</span></h2>

            <Dispositivo
                brand={brandXiaomi}
                className={"dispositivoBox1"}
                title={"Xiaomi Mi box"}
                copy={"Conéctate a un mundo de contenido y entretenimiento en casa con Mi Box. Se ejecuta en el último Android TV 6.0 que es fácil de usar, admite controles de voz y Google CastTM. Vea sus programas de TV favoritos, juegue, ver las noticias o cambiar a la radio."}
                link={"https://dhnn.com"}
                image={xiaomi}
            />

            <Dispositivo
                classNameBox={"google"}
                brand={brandGoogle}
                className={"dispositivoBox2"}
                title={"Google chromecast"}
                copy={"Chromecast es una tecnología que le permite transmitir su entretenimiento y aplicaciones favoritas desde su teléfono, tableta o computadora portátil directamente a su televisor o parlantes."}
                link={"https://dhnn.com"}
                image={google}
            />

            <Dispositivo
                classNameBox={"amino"}
                brand={brandAmino}
                className={"dispositivoBox3"}
                title={"Amino"}
                copy={"El conocimiento de la tecnología de IPTV de Amino brinda las capacidades y funcionalidades que los proveedores de TV paga requieren además de las funciones principales de Android TV de Google."}
                link={"https://dhnn.com"}
                image={amino}
            />

        </div>
        
    </section>

  )
}

export default ListadoDispositivos